import React from 'react';
import { HashRouter } from 'react-router-dom';
import './App.css';
import { CssBaseline, ThemeProvider } from '@mui/material';
import mdTheme from './Theme';
import Routes from './routes/Routes';
import { ErrorHandlerComponent } from './components';

const App = () => (
    <HashRouter>
        <CssBaseline enableColorScheme />
        <ThemeProvider theme={mdTheme}>
            <ErrorHandlerComponent>
                <Routes />
            </ErrorHandlerComponent>
        </ThemeProvider>
    </HashRouter>
);

export default App;
